import React, { useState, useEffect } from "react";
import {LivingDesignProvider} from "@livingdesign/react";
import { trackPage } from "../../utils/appInsight";
import { useLocation } from "react-router-dom";
import ErrorPage from "../ErrorPage";
import NavBar from "../../components/v2/NavBar/NavBar";
import SideMenu from "../../components/v2/SideMenu/SideMenu";
import "./Page.scss";
import Footer from "../../components/v2/Footer/Footer";
import "@livingdesign/react/dist/styles.css";
import "@livingdesign/everyday-sans/dist/EverydaySans.css";
import QA from "../../consts/QA";


// MUI
import {
  useMediaQuery,
} from "@material-ui/core";
import { createTheme } from "../../consts/MuiTheme";
import { ThemeProvider } from "@material-ui/core/styles";
import SnackBar from "../../components/core/SnackBar";

export const QA_ID_PREFIX = QA.PAGES.PAGEV2

function Page({
  user,
  title,
  error,
  clearError,
  showHeader = true,
  showFooter = false,
  fixedHeader = true,
  fixedFooter = false,
  children,
  ccmConfig,
  showAlertBanner,
  setPageTitle,
}) {
  const location = useLocation();

  //MUI
    const prefersDarkMode = false;
    const [theme, setTheme] = useState(createTheme(false));

  /**
   * send the page view event to adobe
   * on route change
   */
  useEffect(() => {
    if (!error && title) {
      trackPage({
        name: title,
      });
      setPageTitle(title);
    }
  }, [location?.pathname]);

  return (
    <>
    <ThemeProvider theme={theme}>
    <LivingDesignProvider>
      <main className="page-main-container" data-testid={`${QA_ID_PREFIX}_MAIN`}>
        {!error ? (
          <div id="main" data-testid={`${QA_ID_PREFIX}_MAIN_CONTAINER`}>
            <div id="main-header" data-testid={`${QA_ID_PREFIX}_HEADER`}>
            {showHeader && <NavBar user={user} fixed={fixedHeader} />}
            </div>
            <div className="page-main-grid-row" data-testid={`${QA_ID_PREFIX}_GRID_ROW`}>
              <div className="page-main-grid-col-1" data-testid={`${QA_ID_PREFIX}_GRID_COL_1`}>
                <SideMenu />
              </div>
              <div className="page-main-grid-col-2" data-testid={`${QA_ID_PREFIX}_GRID_COL_2`}>{children}</div>
            </div>
            <div id="main-footer" data-testid={`${QA_ID_PREFIX}_FOOTER`}>
            <Footer />
            </div>
          </div>
        ) : (
          <ErrorPage error={error} clearError={clearError} data-testid={`${QA_ID_PREFIX}_ERROR_PAGE`} />
        )}
        <SnackBar />
      </main>
      </LivingDesignProvider>
      </ThemeProvider>
    </>
  );
}

export default Page;
